import { CustomStringParam, SchemaFilterType } from '@ui/src';

export const overviewAccountsColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'transferDate',
    label: 'Date',
  },
  {
    name: 'counterpartyAccountNumber',
    label: 'Account No.',
  },
  {
    name: 'counterpartyFullName',
    label: 'Account Name',
  },
  {
    name: 'currencyId',
    label: 'Currency',
  },
  {
    name: 'debitSum',
    label: 'Debit',
  },
  {
    name: 'creditSum',
    label: 'Credit',
  },
];

export const overviewAccountsColumnsLabels = {
  transferDate: 'Date',
  transferDateFrom: 'Date From',
  transferDateTo: 'Date To',
  type: 'Type',
  currencyId: 'Currency',
  documentNumber: 'Doc ID',
  debitSum: 'Debit',
  creditSum: 'Credit',
};

export const overviewAccountsSchema = {
  transferDate: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
    queryNames: ['transferDateFrom', 'transferDateTo'],
  },
  transferDateFrom: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  transferDateTo: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  account: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  currencyId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  debitSum: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  creditSum: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
};

export const overviewAccountsFiltersSchema = [];
